"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _error_template = _interopRequireDefault(require("../error_template/error_template"));

var _index = require("../../../material/index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// error message
// material

/* ========== ~~~~~~~~~~ EXPORT : ERROR : 403 ~~~~~~~~~~ ========== */


var _default = function _default(props) {
  return _react.default.createElement(_error_template.default, {
    styles: 'error403',
    code: "403",
    title: _react.default.createElement("h2", null, "Forbidden"),
    bodycopy: _react.default.createElement("p", null, "We\u2019re sorry, you do not have permission to view this page or resource."),
    button: _react.default.createElement(_index.Button, {
      type: "custom",
      handleClick: function handleClick(e) {
        return window.history.back();
      },
      variant: "primary",
      name: "back",
      text: "Back"
    }),
    illustration: _react.default.createElement(_index.Illustration, {
      name: "error-403",
      text: "Error Illustration"
    })
  });
};

exports.default = _default;